<template>
  <div class="page-layout">
    <div class="page-content">
      <AppBreadcrumbs :items="breadcrumbItems" />
      <h1>Новая поездка</h1>
      <TripForm
        v-model:name="name"
        v-model:trip-date="tripDate"
        v-model:track-completion-id="trackCompletionId"
        v-model:body="body"
        v-model:pending-photos="pendingPhotos"
        v-model:companions="companions"
        v-model:is-public="isPublic"
        v-model:allow-comments="allowComments"
        autofill-trip-date-from-completion
        :error="error"
        :submitting="submitting"
        :cancel-to="{ name: 'trips-home' }"
        @submit="submit"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import AppBreadcrumbs from '../components/AppBreadcrumbs.vue'
import TripForm from '../components/TripForm.vue'
import { createTrip } from '../api/trips'

const router = useRouter()

const breadcrumbItems = [
  { label: 'Поездки', to: { name: 'trips-home' } },
  { label: 'Новая поездка' },
]

const name = ref('')
const tripDate = ref('')
const trackCompletionId = ref('')
const body = ref('')
const pendingPhotos = ref([])
const companions = ref([])
const isPublic = ref(false)
const allowComments = ref(false)
const submitting = ref(false)
const error = ref('')

async function submit() {
  submitting.value = true
  error.value = ''
  try {
    const { data } = await createTrip(
      {
        name: name.value,
        trip_date: tripDate.value,
        body: body.value,
        track_completion_id: trackCompletionId.value || null,
        public: isPublic.value,
        allow_comments: allowComments.value,
        companion_user_ids: companions.value.map((user) => user.id),
      },
      pendingPhotos.value.map((photo) => photo.file)
    )
    router.push({ name: 'trip', params: { id: data.id } })
  } catch (err) {
    error.value = err.response?.data?.errors?.join(', ') || 'Не удалось сохранить поездку'
  } finally {
    submitting.value = false
  }
}
</script>
